import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class StripeBalanceService {
  static async balance(subpropertyId) {
    const response = await graphqlClient.query({
      query: gql`
        query BALANCE(
          $subpropertyId: String!
        ) {
          stripeSubpropertyDataFind(
            subpropertyId: $subpropertyId
          ) {
            connectedAccount {
              id
              settings {
                payoutsScheduleInterval
                payoutsScheduleWeeklyAnchor
                payoutsScheduleMonthlyAnchor
              }
            }
            balanceAvailable{
              amount
              currency
            }
            balancePending{
              amount
              currency
            }
            balanceInTransit{
              amount
              currency
            }
            balanceTotal{
              amount
              currency
            }
          }
        }
      `,

      variables: {
        subpropertyId
      },
    });

    return response.data.stripeSubpropertyDataFind;
  }
}
